import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '~/App';
import reportWebVitals from 'reportWebVitals';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import allReducer from './Reducers';

const store = createStore(
  allReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
);

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

const renderApp = () => {
  root.render(
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>,
  );
};

renderApp();

reportWebVitals();

if (module.hot) module.hot.accept('~/App', () => renderApp());
